import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiSelectOption } from '@maced/angular-components/lib/multi-select/multi-select.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent {
  helperTextId='multiSelectErrorId'
  selectedOptionList: MultiSelectOption[] = [
    {
      id: 'option1',
      name: 'option1',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close',
      icon: 'icon-check-circle'
    }
  ];
  options: MultiSelectOption[] = [
    {
      id: 'option1',
      name: 'option1',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close',
      icon: 'icon-check-circle'
    },
    {
      id: 'option2',
      name: 'option2',
      label: 'option 2',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close',
      icon: 'icon-check-circle'
    },
    {
      id: 'option3',
      name: 'option3',
      label: 'option 3',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option4',
      name: 'option4',
      label: 'option 4',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    }
  ];

  selectedOptionList2: MultiSelectOption[] = [];
  options2: MultiSelectOption[] = [
    {
      id: 'option21',
      name: 'option21',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option22',
      name: 'option22',
      label: 'option 2',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option23',
      name: 'option23',
      label: 'option 3',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option24',
      name: 'option24',
      label: 'option 4',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    }
  ];

  selectedOptionList3: MultiSelectOption[] = [];
  options3: MultiSelectOption[] = [
    {
      id: 'option31',
      name: 'option31',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option32',
      name: 'option32',
      label: 'option 2',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option33',
      name: 'option33',
      label: 'option 3',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option34',
      name: 'option34',
      label: 'option 4',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    }
  ];

  options4: MultiSelectOption[] = [
    {
      id: 'option41',
      name: 'option41',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option42',
      name: 'option42',
      label: 'option 2',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option43',
      name: 'option43',
      label: 'option 3',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option44',
      name: 'option44',
      label: 'option 4',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    }
  ];
  options5: MultiSelectOption[] = [
    {
      id: 'option51',
      name: 'option51',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option52',
      name: 'option52',
      label: 'option 2',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option53',
      name: 'option53',
      label: 'option 3',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option54',
      name: 'option54',
      label: 'option 4',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    }
  ];
  options6: MultiSelectOption[] = [
    {
      id: 'option61',
      name: 'option61',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option62',
      name: 'option62',
      label: 'option 2',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option63',
      name: 'option63',
      label: 'option 3',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option64',
      name: 'option64',
      label: 'option 4',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    }
  ];
  selectedOptionList7: MultiSelectOption[] = [
    {
      id: 'option1',
      name: 'option1',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close',
      icon: 'icon-check-circle'
    }
  ];
  options7: MultiSelectOption[] = [
    {
      id: 'option71',
      name: 'option71',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option72',
      name: 'option72',
      label: 'option 2',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option73',
      name: 'option73',
      label: 'option 3',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option74',
      name: 'option74',
      label: 'option 4',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    }
  ];
  options8: MultiSelectOption[] = [
    {
      id: 'level1',
      name: 'level1',
      label: 'Speak your mind - Level 1',
      disabled: false,
      isTitle: true
    },
    {
      id: 'assessment',
      name: 'assessment',
      label: 'Assessment',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'homework',
      name: 'homework',
      label: 'Homework',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'preparationAndPractice',
      name: 'preparationAndPractice',
      label: 'Preparation and Practice',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'mainCourseBook',
      name: 'mainCourseBook',
      label: 'Main Course Book',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'Beginner',
      name: 'Beginner',
      label: 'Language Hub - Beginner',
      disabled: false,
      isTitle: true
    },
    {
      id: 'assessmentLH',
      name: 'assessmentLH',
      label: 'Assessment',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'homeworkLH',
      name: 'homeworkLH',
      label: 'Homework',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'practiceQuiz',
      name: 'practiceQuiz',
      label: 'Practice Quiz',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'studentsBook',
      name: 'studentsBook',
      label: 'Students Book',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
  ];
  selectedOptionList4: MultiSelectOption[] = [];

  noJsOptions: MultiSelectOption[] = [
    {
      id: '21Lession',
      name: '21Lession',
      label: '2.1 Lession important decisions ',
      disabled: false,
      checked: false,
      url: '/multi-select'
    },
    {
      id: '22Lession',
      name: '22Lession',
      label: '2.2 Lession you can do it!',
      disabled: false,
      checked: false,
      url: '/multi-select'
    },
    {
      id: '23Lession',
      name: '23Lession',
      label: '2.3 Lession Speaking',
      disabled: false,
      checked: false,
      url: '/multi-select'
    }   
  ];
   selectedOptionListNoJs: MultiSelectOption[] = [];
   
  useCase = 'SelectWithChipsInput';
  selectedUseCase = 'SelectWithChipsInput';
  useCases: string[] = [
    'SelectWithChipsInput',
    'InlineSelect',
    'MultiSections', 
    'ErrorMode',
    'DisabledMode',
    'InLineSelectWithDisabledMode',
    'SelectOnlySingleOption'
  ];
  isBrowser = true;
  public queryParamSubscription!: Subscription;
  params: any;
  checked:any;
    options9: MultiSelectOption[] = [
    {
      id: 'option91',
      name: 'option91',
      label: 'option 1',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option92',
      name: 'option92',
      label: 'option 2',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option93',
      name: 'option93',
      label: 'option 3',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    },
    {
      id: 'option94',
      name: 'option94',
      label: 'option 4',
      disabled: false,
      checked: false,
      closeButtonArialabel: 'Close'
    }
  ];
    selectedOptionList8: MultiSelectOption[] = [this.options9[0]]

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }

  ngOnInit(): void {
    if (!this.isBrowser) {
      this.queryParamSubscription = this.route.queryParams.subscribe(param => {   
        this.selectedOptionList = [];
        this.selectedOptionList7 = [];
        let snapshot = this.route.snapshot;
        let queryParams = { ...snapshot.queryParams };

        if (param['chipId'] && param['isDelete']) {
          delete queryParams[param['chipId']];
          delete queryParams['chipId'];
          delete queryParams['isDelete'];
          this.router.navigate(['/multi-select'], { queryParams: queryParams });
        }

        this.options = this.options6.map((obj: MultiSelectOption) => {
          if (param[obj.id] ) {
            this.selectedOptionList.push(obj);
            obj.checked = true;
          } else {
            obj.checked = false;
          }
          return obj;
        });
        this.options7 = this.options7.map((obj: MultiSelectOption) => {
          if (param[obj.id] ) {
            this.selectedOptionList7.push(obj);
            obj.checked = true;
          } else {
            obj.checked = false;
          }
          return obj;
        });
        this.options8 = this.options8.map((obj: MultiSelectOption) => {
          if (param[obj.id] ) {
            this.selectedOptionList4.push(obj);
            obj.checked = true;
          } else {
            obj.checked = false;
          }
          return obj;
        });
        if (param.id && param.id === 'multiSelectIdNoJs') {
          this.noJsOptions = this.noJsOptions.map((obj: MultiSelectOption) => {
            if (obj.id === param.selectedMultiDropdownOptionId) {
              obj.checked = true;
              this.selectedOptionListNoJs.push(obj);
            } else {
              obj.checked = false;
            }
            return obj;
          });
        }
      });
    }
  }

  onClickOption(selectedOptionList: MultiSelectOption[]) {
    this.selectedOptionList = selectedOptionList;
  }

  onClickOption2(selectedOptionList: MultiSelectOption[]) {
    this.selectedOptionList2 = selectedOptionList;
  }

  onClickOption3(selectedOptionList: MultiSelectOption[]) {
    this.selectedOptionList3 = selectedOptionList;
  }

  onClickOption4(selectedOptionList: MultiSelectOption[]) {
    this.selectedOptionList4 = selectedOptionList;
  }
  onClickOption8(selectedOptionList: MultiSelectOption[]) {
    this.selectedOptionList8 = selectedOptionList;
  }
}